import { createApp, watch } from 'vue';
import { createPinia } from 'pinia';
import { useCalendarsStore } from './stores/calendars';
// import { useFontsStore } from './stores/fonts';
// import { useAuthStore } from './stores/auth';

import { msalPlugin, msalInstance } from 'vue3-msal-plugin'
import type { AccountInfo, Configuration } from '@azure/msal-browser'
import type { AuthenticationResult } from '@azure/msal-browser'
import { EventType } from '@azure/msal-browser'

import { useUserStore } from './stores/user'

import './assets/main.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';

import * as FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css'

import App from './App.vue';
import router from './router';

console.log('Initializing Speedo');

const app = createApp(App);

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority: import.meta.env.VITE_AUTHORITY,
    // Origin-based so local dev returns to localhost and production to speedo; both must be registered as SPA redirect URIs.
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/'
  },
  cache: {
    cacheLocation: 'localStorage'
  }
}

// Create a new MSAL instance with the defined configuration
const newMsalInstance = msalInstance(msalConfig)

await newMsalInstance.initialize()

// Get all accounts from the MSAL instance
const accounts = newMsalInstance.getAllAccounts()
if (accounts.length > 0) {

  // If there are any accounts, set the first one as the active account
  newMsalInstance.setActiveAccount(accounts[0])
}

app.use(FloatingVue);
app.use(createPinia())
app.use(router)

const store = useCalendarsStore()

const { updateUser } = useUserStore()

// Add an event callback to the MSAL instance
newMsalInstance.addEventCallback(async (event) => {
  // If the event is a successful login and the event has a payload
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {

    // Cast the payload to an AuthenticationResult // Wrong, should be AccountInfo
    const payload = event.payload as AccountInfo;

    // Get the account from the payload
    const account = payload as AccountInfo;

    // Set the account as the active account in the MSAL instance
    newMsalInstance.setActiveAccount(account)

    /* Optioanlly, You can update the user store with the account data here.
    'account' refers to the account data obtained from the MSAL instance.
    */
    updateUser(account)

    store.getLocalStorage();
    await store.loadSharedData();
    await store.loadLightboxes(account.username, true);
    await store.loadCalendars(true);
  }
  else {
    console.log('MSAL Event:', event.eventType);
  }
})

// Use the vue3-msal plugin with the MSAL instance
app.use(msalPlugin, newMsalInstance)

// Handle page refresh
// Get the active account from the MSAL instance
const activeAccount = newMsalInstance.getActiveAccount()
if (activeAccount) {
  /* Optioanlly, you can update the user store with the account data here.
    'account' refers to the account data obtained from the MSAL instance.
    */
  updateUser(activeAccount)

  console.log('activeAccount:', activeAccount);

  store.getLocalStorage();
  await store.loadSharedData();
  await store.loadLightboxes(activeAccount.username, true);
  await store.loadCalendars(true);
}

app.mount('#app');






// const pinia = createPinia();
// app.use(pinia);

// const auth = useAuthStore();
// auth.init();

// const store = useCalendarsStore(); // Initialize state whether signed in or not
// const fontsStore = useFontsStore(); 

// watch(
//   () => auth.account?.username,
//   async (newValue,oldValue) => {
//     // Not triggered by SignOut
//     // console.log('watch auth.account', newValue, oldValue)
//     store.getLocalStorage();
//     await store.loadSharedData();
//     await store.loadLightboxes(auth.account.username, true);
//     await store.loadCalendars(true);
//     await fontsStore.loadGoogleFonts();
//   },
//   { deep: true }
// );

// app.use(router);

// app.mount('#app');

// console.log('App Mounted');